<template>
	<div class="add_backimg add_backimgTop clearfix">
		<div class="nav_list">
			<span class="primaryColor"><i class="el-icon-location-outline"></i>当前位置：</span>
			<span class="pointer" @click="toName('index')">首页<i class="el-icon-arrow-right"></i></span>
			<span class="pointer" @click="toName('courses')">在线课程<i class="el-icon-arrow-right"></i></span>
			<span>课程详情</span>
		</div>
		<div class="course_cont">
			<div class="course_contMain clearfix">
				<div class="course_mainLeft">
					<div class="course_leftTop text-ellipsis">
						<div class="course_leftType">{{course.type}}</div>
						<span>【{{course.name}}】</span>
						<div class="course_leftInfo">
							授课老师：{{course.username}}
							<span class="content_leftstep">|</span> {{course.signCount || '0'}}人已学习
							<span class="content_leftstep">|</span> {{course.collectionCount || '0'}}人已收藏
						</div>
					</div>
					<div class="course_leftBottom">
						<div class="course_leftMenu  clearfix">
							<img src="@/images/course_playIcon.png" class="course_playIcon" />
							<span v-if="false">{{chapterName}}</span>
							<div class="text-ellipsis">{{sectionName}}-{{fileName}}</div>
							<div class="course_playListBtn" @click="playList = !playList" v-if='course.children'>
								<i class="el-icon-s-order"></i>
								<span>本节课件</span>
								<i class="el-icon-arrow-down"></i>
							</div>
							<div class="course_playList beautifulScroll" v-show='playList'>
								<div v-if="chapter == index" v-for="(item,index) in course.children">
									<div v-if="section==idx" v-for="(it,idx) in item.children">
										<div class="course_playItem" v-if="!it.children || it.children.length<=0">暂无课件</div>
										<div class="course_playItem text-ellipsis" v-for="(file,fileide) in it.children">
											<img src="@/images/course_typeIcon2.png" class="course_typeIcon" v-if='file.type==0' />
											<img src="@/images/course_typeIcon1.png" class="course_typeIcon" v-else/>
											<span>{{file.name}}</span>
											<div class="course_playIn" @click="learn(index,idx,fileide,'change')">查看</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="course_leftPlay">
							<video :src="playType == '0' && playUrl?baseurl + playUrl:''" v-show="playType == '0'" autoplay controls="controls" controlsList="nodownload" :poster="course.banner?baseurl+course.banner:''"></video>
							<iframe :src="'./pdfjs/web/viewer.html?file=' + basePdfapi" v-if="playType != '0' && playType != '5' && basePdfapi"></iframe>
							<iframe :src="playUrl" v-if="playType == '5'"></iframe>
						</div>
					</div>
				</div>
				<div class="course_mainRight">
					<div class="course_rightInfo">
						<div class="course_infoMain">
							<span>共 {{chapterLength}}章，{{sectionLength}}节课</span>
							<img @click="moocCollection(course)" src="@/images/course_collect2.png" v-if="course.isCollection" />
							<img @click="moocCollection(course)" src="@/images/course_collect1.png" v-if="!course.isCollection" />
						</div>
						<div class="course_infoBox">
							<div class="course_infoText text-ellipsistwo">
								<div>课程介绍：{{course.info || '暂无'}}</div>
								<div>参考资料：{{course.references || '暂无'}}</div>
								<div>课程概述：</div>
								<div v-html="course.overview"></div>
							</div>
							<div class="course_infoOpen" @click="toActiveTab('info')">详情 <i class="el-icon-arrow-right"></i></div>
						</div>
					</div>
					<div class="course_rightNavs">
						<div class="course_navBox" :class="'course_navBox'+typeindex">
							<div class="course_navItem" :class="typeindex==index?'active':''" @click="changeNav(index)" v-for="(item,index) in othertypes">
								{{item}}
							</div>
						</div>
						<div class="course_chapterBox" v-show="typeindex==0">
							<div class="course_chapterList hiddenScroll" v-if='course.children'>
								<div class="course_sectionBox" v-for="(item,index) in course.children">
									<div class="course_chapterItem text-ellipsis" @click="changeChapterOpen(index)">
										<span>{{item.name}}</span>
										<i class="el-icon-arrow-down"></i>
									</div>
									<el-collapse-transition>
										<div class="course_sectionList" v-show="chepteropen==index">
											<div class="course_fileBox" v-for="(it,idx) in item.children">
												<div class="course_sectionItem text-ellipsis">
													{{it.name}}
												</div>
												<div class="course_fileList">
													<div class="course_fileItem text-ellipsis" @click.stop="learn(index,idx,fileide,'change')" v-for="(file,fileide) in it.children" :class="chapter == index && section==idx && fileindex == fileide?'active':''">
														<div class="course_fileIcon">
															<img src="@/images/course_playing1.png" v-if='chapter == index && section==idx && fileindex == fileide' />
															<img src="@/images/course_playing0.png" v-else/>
														</div>
														<span>{{file.name}}</span>
														<div class="course_fileStatus" :class="chapter == index && section==idx && fileindex == fileide?'active':''">
															<div v-if='chapter == index && section==idx && fileindex == fileide'>
																<img src="@/images/wave.png" />正在学习
															</div>
															<div v-else>
																<span v-if='file.isWatchFinish == 0 && file.type==0' class="r">学至({{file.second | spliceForSecond}})</span>
																<span v-if='file.isWatchFinish == 1 && file.type==0' class="r">已学完 </span>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</el-collapse-transition>
								</div>
							</div>
						</div>
						<div class="course_chatBox" v-show="typeindex==1">
							<div class="course_chatList hiddenScroll" id="course_communicate">
								<div class="course_chatItem clearfix" :class="item.userId == userinfo.userId?'isMine':'isnotMine'" v-for="(item,index) in communicateList">
									<div class="course_chatIcon">
										<img src="@/images/1.png" />
									</div>
									<div class="course_chatInfo">
										<span>{{item.username}}</span>
										<span>{{item.createTime}}</span>
									</div>
									<div class="course_chatText">
										{{item.content}}
									</div>
								</div>
							</div>
							<div class="course_chatInput">
								<input type="text" v-model="communicateCont" placeholder="请输入内容，按enter发送" @keyup.enter="addCommunicate()"/>
								<button type="button" @click="addCommunicate">发送</button>
							</div>
						</div>
						<div class="course_noteBox" v-show="typeindex==2">
							<div class="course_noteInput darkInput">
								<div class="course_noteTop">
									<div id="toolbar">
										<button class="ql-bold"></button>
										<button class="ql-italic"></button>
										<button class="ql-image"></button>
										<select class="ql-align">
											<option value="justify" selected></option>
											<option value="center"></option>
											<option value="right"></option>
										</select>
									</div>
								</div>
								<div class="course_noteTite">
									<input v-model="title" type="text" placeholder="请输入标题" />
								</div>
								<div class="course_noteCont">
									<quill-editor class="editor" ref="myQuillEditor" :content="content" @change="onEditorChange($event)" :options="editorOption"></quill-editor>
								</div>
								<div class="uploadBox" v-show="false">
									<div class="uploadList">
										<el-upload action="" :with-credentials='true' :on-success='uploadsuccess' :multiple='false' name='file' accept='image/*' :show-file-list='false' :http-request="formRequest">
											<div class="uploadbtninner">
												<i class="el-icon-plus"></i>
											</div>
										</el-upload>
										<div style="clear: both;"></div>
									</div>
								</div>
							</div>
							<img @click="noteChapters" src="@/images/course_notoSave.png" class="course_notoSave" />
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="course_contBottom clearfix" ref='contBottom'>
			<div class="course_bottomMenus">
				<div class="course_bottomMenu" :class="showindex == item.id?'active':''" @click="showindex = item.id" v-for='(item,index) in navList'>
					<img :src="item.activeIcon" class="activeIcon" />
					<img :src="item.icon" class="normalIcon" />
					<el-badge :is-dot='item.isDot'>
						<div class="course_menuText">
							{{item.name}}
							<span class="course_bottomInfo">{{index == 2 && commontTotal?'('+commontTotal+')':''}}</span>
						</div>
					</el-badge>
				</div>
			</div>
			<course-info v-if="showindex == 'info'" :courseId="courseId"></course-info>
			<course-task v-if="showindex == 'task'" :courseId="courseId" :chapterId='chapterId' :sectionId='sectionId'></course-task>
			<course-commont v-if="showindex == 'commont'" :courseId="courseId" :chapterId='chapterId' :sectionId='sectionId' @commentAdd='getCommentList'></course-commont>
			<course-note v-if="showindex == 'note'" :courseId="courseId" :chapterId='chapterId' :sectionId='sectionId' :chapterName='chapterName' :sectionName='sectionName'></course-note>
		</div>
		<el-dialog title="课堂试题" class="open_dialogInfo" :visible.sync="fileAskShow" :append-to-body='true' width="600px" :close-on-click-modal='false' :close-on-press-escape='false' :show-close='false'>
			<div class="course_askBox">
				<course-ask v-if='fileAskShow' :qusetionlist='qusetionlist' :questionindex='fileAskIndex' @skipAsk='skipAsk' @closeAsk='closeAsk' @relookAsk='relookAsk'></course-ask>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import { getInfo } from '@/api/user.js'
	import { scrollBottom } from '@/utils/auth.js'
	import { putProgress } from "@/utils/oss.js";
	import { commentList } from '@/api/comment.js'
	import { notePublish } from '@/api/note.js'
	import { getStorageToken, heightToTop } from '@/utils/auth'
	import { appCourseTree, sign, getListByFileId, getCommunicate, addCommunicate } from '@/api/course.js'
	import { sectionupdate, sectionlist } from '@/api/section.js'
	import { collectionSave, collectionDelete } from '@/api/collection'
	import courseAsk from '@/views/courses/components/courseAsk.vue'
	import courseInfo from '@/views/courses/components/courseInfo.vue'
	import courseTask from '@/views/courses/components/courseTask.vue'
	import courseCommont from '@/views/courses/components/courseCommont.vue'
	import courseNote from '@/views/courses/components/courseNote.vue'
	export default {
		name: 'coursedetail',
		components: {
			courseAsk,
			courseInfo,
			courseTask,
			courseCommont,
			courseNote
		},
		data() {
			return {
				courseId: this.$route.query.courseId,
				toTab: this.$route.query.toTab,
				userinfo: {},
				course: {},
				chapterLength: 0,
				sectionLength: 0,
				fileLength: 0,
				chapter: -1,
				chapterId: null,
				chapterName: '',
				section: -1,
				sectionId: null,
				sectionName: null,
				fileindex: -1,
				fileId: null,
				fileName: null,
				playList: false,
				commontTotal: 0,
				firstnav: true,
				navList: [{
					isDot: false,
					num: 0,
					name: '课程详情',
					id: 'info',
					activeIcon: require('@/images/course_nav1A.png'),
					icon: require('@/images/course_nav1.png'),
				}, {
					isDot: false,
					num: 0,
					name: '课程作业',
					id: 'task',
					activeIcon: require('@/images/course_nav2A.png'),
					icon: require('@/images/course_nav2.png')
				}, {
					isDot: false,
					num: 58,
					name: '课堂讨论',
					id: 'commont',
					activeIcon: require('@/images/course_nav3A.png'),
					icon: require('@/images/course_nav3.png')
				}, {
					isDot: false,
					num: 0,
					name: '课堂笔记',
					id: 'note',
					activeIcon: require('@/images/course_nav4A.png'),
					icon: require('@/images/course_nav4.png')
				}],
				teacherall: false,
				typeindex: 0,
				othertypes: ['课程目录', '在线交流', '记笔记'],
				showindex: 'info',
				chepteropen: 0,
				playUrl: '',
				dataloading: false,
				//笔记
				content: '',
				description: '',
				title: '',
				//视频
				maxSecond: 0,
				basePdfapi: '',
				play_url: '',
				playType: '',
				poster: '',
				//视频试题
				fileAskShow: false,
				fileAskIndex: -1,
				qusetionlist: [],
				fileAskTime: [],
				//在线聊天
				communicateCont: '',
				communicateList: [],
				//富文本
				editorOption: {
					modules: {
						toolbar: '#toolbar',
					},
					placeholder: '请输入内容',
				},
			}
		},
		created() {
			this.getMyUserInfo();
		},
		mounted() {
			this.$nextTick(() => {
				if(this.toTab) {
					this.toActiveTab(this.toTab)
				}
				this.videoplay();
			})
		},
		methods: {
			getCommunicate() {
				getCommunicate({
					courseId: this.courseId
				}).then(res => {
					this.communicateList = res.data;
					this.$nextTick(() => {
						scrollBottom('course_communicate')
					})
				})
			},
			addCommunicate() {
				if(!this.communicateCont) {
					this.$message({
						type: 'error',
						message: "请输入内容！"
					})
					return
				}
				addCommunicate({
					courseId: this.courseId,
					content: this.communicateCont
				}).then(res => {
					this.communicateCont = '';
					this.getCommunicate();
				})
			},
			getMyUserInfo() {
				getInfo().then(res => {
					if(res.code == 'OK') {
						const {
							data
						} = res;
						this.userinfo = data;
						this.getCommunicate();
						this.getCourseinfo();
					}
				})
			},
			getCourseinfo() {
				var data = {
					courseId: this.courseId
				}
				appCourseTree(data).then(res => {
					if(res.code == "OK") {
						if(res.data) {
							this.course = res.data;
							this.cuorsesign();
						} else {
							this.$alert('未查询到课程内容，可能当前课程未发布，请查看其它课程！', '提示', {
								confirmButtonText: '确定',
								callback: action => {
									this.toName('courses')
								}
							});
						}
					}
				})
			},
			toName(name) {
				var token = getStorageToken();
				if(token) {
					if(this.$router.name != name) {
						this.$router.push({
							name: name
						})
					}
				} else {
					this.$store.dispatch('user/openLogin', {
						loging: true
					})
				}
			},
			cuorsesign() {
				var data = {
					courseId: this.courseId
				}
				sign(data).then(res => {
					this.getSectionList('start');
				})
			},
			getSectionList(type) {
				var that = this;
				var data = {
					courseId: this.courseId
				}
				sectionlist(data).then(res => {
					if(res.code == "OK" && res.data) {
						var data = res.data;
						var lastchapter = 0;
						var lastsection = 0;
						var lastfileindex = 0;
						var coursetree = this.course.children;
						data.map(item => {
							coursetree.map((chapter, index) => {
								chapter.children.map((section, ide) => {
									section.children.map((file, fileide) => {
										if(item.chapterId == chapter.id && item.sectionId == section.id && item.fileId == file.id) {
											that.hasStart = true;
											file.isLast = item.isLast;
											file.isWatchFinish = item.isWatchFinish;
											file.maxSecond = item.maxSecond;
											file.second = item.second;
											if(item.isLast == 1) {
												lastchapter = index;
												lastsection = ide;
												lastfileindex = fileide;
											}
										}
									})
								})
							})
						})
						this.course = Object.assign({}, this.course, {
							children: coursetree
						})
						if(type == 'start') {
							this.learn(lastchapter, lastsection, lastfileindex, type);
						}
					}
				})
			},
			learn(chapter, section, fileindex, type) {
				this.playList = false;
				var course = this.course;
				if(this.chapter != chapter || this.section != section || this.fileindex != fileindex) {
					if(type == 'change') {
						this.videoOldClear()
					}
					this.chapter = chapter;
					this.section = section;
					this.fileindex = fileindex;
					var coursetree = this.course.children;
					this.chapterLength = coursetree.length;
					coursetree.map((chapters, index) => {
						this.sectionLength += chapters.children.length;
						if(chapter == index) {
							this.chapterId = chapters.id;
							this.chapterName = chapters.name;
						}
						chapters.children.map((sections, ide) => {
							this.fileLength += sections.children.length;
							if(chapter == index && section == ide) {
								this.sectionId = sections.id;
								this.sectionName = sections.name;
							}
							sections.children.map((files, fileide) => {
								if(chapter == index && section == ide && fileindex == fileide) {
									this.fileId = files.id;
									this.fileName = files.name;
									this.playUrl = files.playUrl;
									this.playType = files.type;
									if(files.type != "0") {
										this.basePdfapi = encodeURIComponent(this.baseurl + files.playUrl);
									}
									this.qusetionlist = [];
									this.fileAskTime = [];
									this.getListByFileId();
									this.videobreak();
									this.getCommentList();
								}
							})
						})
					})
				}
			},
			videoplay() {
				if($('video').length <= 0) {
					return
				}
				var that = this;
				$('video').on('play', function(e) {
					var sectionId = that.sectionId
					var currentTime = $('video').get(0).currentTime
					that.toUpdaateSection(sectionId, currentTime, 0)
				})
				$('video').on('timeupdate', function(e) {
					var sectionId = that.sectionId;
					var currentTimeOld = window.localStorage.getItem('videoplaying' + sectionId);
					currentTimeOld = Number(currentTimeOld);
					var currentTimeNew = $('video').get(0).currentTime;
					if(currentTimeNew - that.maxSecond > 1.5) {
						$('video')[0].currentTime = currentTimeOld;
					} else {
						window.localStorage.setItem('videoplaying' + sectionId, currentTimeNew);
						if(that.maxSecond <= currentTimeNew) {
							that.maxSecond = currentTimeNew;
							var fileAskTime = that.fileAskTime;
							var videotime = Math.floor(currentTimeNew);
							var fileAskIndex = fileAskTime.indexOf(videotime);
							if(fileAskIndex != -1) {
								$('video')[0].pause();
								that.fileAskIndex = fileAskIndex;
								that.fileAskShow = true;
							}
						}
					}
				})
				$('video').on('ended', function(e) {
					var sectionId = that.sectionId
					var currentTime = window.localStorage.getItem('videoplaying' + sectionId)
					that.toUpdaateSection(sectionId, currentTime, 1)
					window.localStorage.removeItem('videoplaying' + sectionId)
				})
			},
			videoOldClear() {
				var sectionId = this.sectionId;
				if(this.playType != "0") {
					this.toUpdaateSectionFile(sectionId);
				} else {
					var currentTime = window.localStorage.getItem('videoplaying' + sectionId)
					if(currentTime) {
						this.toUpdaateSection(sectionId, currentTime, 0)
						window.localStorage.removeItem('videoplaying' + sectionId)
					}
				}
				this.maxSecond = 0;
				$('video')[0].currentTime = 0;

			},
			videobreak() {
				if($('video').length <= 0) {
					return
				}
				var data = {
					courseId: this.courseId,
					chapterId: this.chapterId,
					sectionId: this.sectionId,
					fileId: this.fileId,
				}
				sectionlist(data).then(res => {
					if(res.code == "OK" && res.data && res.data.length > 0) {
						var maxSecond = res.data[0].maxSecond;
						maxSecond = Number(maxSecond);
						if(maxSecond && !isNaN(maxSecond)) {
							this.maxSecond = maxSecond;
						} else {
							this.maxSecond = 0;
						}
						var currentTime = res.data[0].second;
						currentTime = Number(currentTime);
						if(currentTime > 0) {
							$('video')[0].currentTime = currentTime;
						}
					} else {
						this.maxSecond = 0;
						$('video')[0].currentTime = 0;
					}
				})
			},
			skipAsk() {
				this.fileAskShow = false;
				var index = this.fileAskIndex;
				this.qusetionlist.splice(index, 1);
				this.fileAskTime.splice(index, 1);
				$('video')[0].play();
			},
			closeAsk() {
				this.fileAskShow = false;
				var index = this.fileAskIndex;
				this.qusetionlist.splice(index, 1);
				this.fileAskTime.splice(index, 1);
				$('video')[0].play();
			},
			relookAsk() {
				this.fileAskShow = false;
				var index = this.fileAskIndex;
				$('video')[0].currentTime = this.qusetionlist[index].errorBackTime;
				$('video')[0].play();
			},
			getListByFileId() {
				var data = {
					fileId: this.fileId,
				}
				getListByFileId(data).then(res => {
					if(res.code == "OK") {
						var qusetionlist = res.data;
						var fileAskTime = [];
						qusetionlist.map(item => {
							fileAskTime.push(item.pointInTime)
						})
						this.qusetionlist = qusetionlist;
						this.fileAskTime = fileAskTime;

					}
				})
			},
			toUpdaateSection(sectionId, second, isWatchFinish) {
				var fileId = this.fileId;
				var second = parseInt(second);
				var maxSecond = parseInt(this.maxSecond);
				maxSecond = maxSecond < second ? second : maxSecond;
				var data = {
					fileId: fileId,
					sectionId: sectionId,
					second: second,
					maxSecond: maxSecond,
				}
				if(isWatchFinish == 1) {
					var duration = $('video')[0].duration;
					if(duration - maxSecond <= 2) {
						data.isWatchFinish = isWatchFinish
					}
				}
				sectionupdate(data).then(() => {
					this.getSectionList('change');
				})
			},
			toUpdaateSectionFile(sectionId) {
				var fileId = this.fileId;
				var data = {
					fileId: fileId,
					sectionId: sectionId,
					second: 0,
					maxSecond: 0,
					isWatchFinish: 1,
				}
				sectionupdate(data).then(() => {
					this.getSectionList('change');
				})
			},
			changeChapterOpen(chepteropen) {
				if(this.chepteropen != chepteropen) {
					this.chepteropen = chepteropen
				} else {
					this.chepteropen = -1
				}
			},
			changeNav(index) {
				if(this.typeindex != index) {
					this.typeindex = index
					if(index == '2' && this.firstnav) {
						this.firstnav = false
						this.editorUpload();
					}
				}
			},
			onEditorChange(res) {
				this.description = res.text;
				this.content = res.html;
			},
			editorUpload() {
				var that = this;
				this.$nextTick(() => {
					var myQuillEditor = that.$refs.myQuillEditor;
					var imgHandler = async function(image) {
						that.addImgRange = that.$refs.myQuillEditor.quill.getSelection();
						if(image) {
							document.getElementsByClassName('uploadbtninner')[0].click()
						}
					}
					that.$refs.myQuillEditor.quill.getModule("toolbar").addHandler("image", imgHandler);
				})
			},
			getCommentList() {
				var data = {
					limit: 1,
					current: 1,
					courseId: this.courseId,
					chapterId: this.chapterId,
					sectionId: this.sectionId,
				}
				commentList(data).then(res => {
					if(res.code == "OK") {
						this.commontTotal = res.data.total;
					}
				})
			},
			noteChapters() {
				this.dataloading = true;
				setTimeout(_ => {
					this.dataloading = false;
				}, 1000)
				if(!this.title) {
					this.$message.error('请输入标题！')
					return
				}
				if(!this.content) {
					this.$message.error('请输入内容！')
					return
				}
				var data = {
					title: this.title,
					content: this.content,
					description: this.description,
					courseId: this.courseId,
					chapterId: this.chapterId,
					sectionId: this.sectionId,
				}
				notePublish(data).then(res => {
					if(res.code == "OK") {
						this.note = false;
						this.content = '';
						this.description = '';
						this.title = '';
						this.$message.success('发布成功，请在课程笔记中查看')
					} else {
						this.$message.error(res.msg)
					}
				})
			},
			get_suffix(filename) {
				let pos = filename.lastIndexOf('.')
				let suffix = ''
				if(pos != -1) {
					suffix = filename.substring(pos)
				}
				return suffix
			},
			formRequest(file) {
				let that = this;
				var dir = 'vr/stuNote/';
				var noeDate = new Date();
				var year = noeDate.getFullYear();
				var month = noeDate.getMonth() + 1;
				month = month < 10 ? '0' + month : month;
				var day = noeDate.getDate();
				day = day < 10 ? '0' + day : day;
				dir = dir + year + "/" + month + "/" + day + '/';
				const uploadfile = file.file;
				const key = dir + noeDate.getTime() + this.get_suffix(file.file.name);
				putProgress(key, uploadfile, function(progressEvent) {
					let e = {}
					e.percent = progressEvent * 100 || 0;
					file.onProgress(e)
				}).then(res => {
					let e = {
						code: "OK",
						success: true,
						message: '',
						data: key
					}
					file.onSuccess(e)
				});
			},
			uploadsuccess(res, file, fileList) {
				var _this = this;
				var baseurl = this.baseurl;
				if(res) {
					var value = baseurl + res.data;
					_this.addImgRange = _this.$refs.myQuillEditor.quill.getSelection()
					_this.$refs.myQuillEditor.quill.insertEmbed(_this.addImgRange != null ? _this.addImgRange.index : 0, 'image', value, null)
				}
			},
			moocCollection(item) {
				var token = getStorageToken();
				if(token) {
					if(!item.isCollection) {
						collectionSave({
							type: 'mooc',
							typeId: item.id
						}).then(res => {
							if(res.code == "OK") {
								this.$message({
									type: 'success',
									message: "收藏成功!",
								})
								var collectionCount = this.course.collectionCount;
								collectionCount ? collectionCount++ : 1;
								this.course = Object.assign({}, this.course, {
									isCollection: true,
									collectionCount: collectionCount
								})
							} else {
								this.$message({
									type: 'error',
									message: res.data.message,
								})
							}
						})
					} else {
						collectionDelete({
							type: 'mooc',
							typeId: item.id
						}).then(res => {
							if(res.code == "OK") {
								this.$message({
									type: 'success',
									message: '取消成功!'
								});
								var collectionCount = this.course.collectionCount;
								collectionCount ? collectionCount-- : 0;
								this.course = Object.assign({}, this.course, {
									isCollection: false,
									collectionCount: collectionCount
								})

							}
						})
					}
				} else {
					this.$store.dispatch('user/openLogin', {
						loging: true
					})
				}
			},
			toActiveTab(showindex) {
				this.showindex = showindex;
				var height = heightToTop(this.$refs.contBottom);
				$("html").animate({
					scrollTop: height
				}, 300);
			},
		},
		beforeRouteLeave(to, from, next) {
			var sectionId = this.sectionId
			var currentTime = window.localStorage.getItem('videoplaying' + sectionId)
			if(currentTime) {
				$('video').unbind('timeupdate')
				$('video').unbind('ended')
				this.toUpdaateSection(sectionId, currentTime, 0)
				window.localStorage.removeItem('videoplaying' + sectionId)
			}
			next();
		},
	}
</script>